<template>
  <div class="indent-detail-container">
    <div class="indent-detail-header">
      订单详情
    </div>
    <div class="timeline-wrapper">
      <el-steps :active="indentDetail.state | purchaseStatusToStep"
                finish-status="success"
                align-center
                :space="250">
        <el-step title="待收货"
                 :description="indentDetail.createOn | date"></el-step>
        <el-step title="待处理"
                 :description="indentDetail.processOn | date"></el-step>
        <el-step title="已完成"
                 :description="indentDetail.completedOn | date"></el-step>
      </el-steps>
    </div>
    <div class="order-time-wrapper">
      <div class="property-row">
        <span>下单时间</span>
        <span>委托订单</span>
      </div>
      <div class="detail-row">
        <span>{{ indentDetail.createOn | date}}</span>
        <span>{{ indentDetail.code }}</span>
      </div>
    </div>
    <div class="order-list-wrapper">
      <h3 class="title">
        物料清单
      </h3>
      <el-table :data="indentDetail.entrustDetails"
                style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="batch-list">
              <div class="batch-item-wrapper"
                   v-for="(item,index) in props.row.entrustReceiptBatchs"
                   :key="index">
                <div class="batch-item">
                  <div class="batch-name">批次号:</div>
                  <div class="data">{{ item.batchCode }}</div>
                </div>
                <div class="batch-item">
                  <div class="batch-name">批次数量:</div>
                  <div class="batch-data">{{ item.quantity }}</div>
                </div>
                <div class="batch-item batch-quality">
                  <div class="batch-name">原始品项:</div>
                  <div class="batch-data">
                    <el-tag :type="item.itemQualityName | qualityType"
                            size="mini">
                      {{ item.itemQualityName }}
                    </el-tag>
                  </div>
                </div>
                <div class="batch-item">
                  <div class="batch-name">检测报价:</div>
                  <div class="batch-data">{{ item.confirmPrice }}</div>
                </div>
                <div class="batch-item">
                  <div class="batch-name">处理结果:</div>
                  <div class="batch-data">入库数：{{ item.stockQuantity }}</div>
                </div>
                <!-- <div class="batch-item">
                  <div class="batch-name">维修记录:</div>
                  <div class="batch-data">无</div>
                </div> -->
                <div class="batch-item">
                  <div class="batch-name">质检结果:</div>
                  <div class="batch-data">{{ item.qualityState }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="物料名称"
                         prop="itemName"
                         width="250">
        </el-table-column>
        <el-table-column label="物料编码"
                         prop="itemCode"
                         width="150">
        </el-table-column>
        <el-table-column label="品项"
                         width="150">
          <template slot-scope="scope">
            <el-tag :type="scope.row.itemQualityName | qualityType"
                    size="mini">
              {{ scope.row.itemQualityName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="品牌"
                         prop="brand"
                         width="150">
        </el-table-column>
        <el-table-column label="机型"
                         prop="machine"
                         width="150">
        </el-table-column>
        <el-table-column label="模块"
                         prop="module"
                         width="150">
        </el-table-column>
        <el-table-column label="采购数量"
                         prop="quantity"
                         width="120">
        </el-table-column>
        <el-table-column label="单价"
                         prop="price"
                         width="120">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      indentDetail: {}
    };
  },
  beforeCreate () {
    this.$store.commit('setActiveIndex', '/indent')
    this.$store.commit('setSubActiveIndex', '/indent')
    this.$store.commit('setAsideWidth', 300)
  },
  created () {
    this.getIndentDetail(this.$route.query.id)
  },
  methods: {
    getIndentDetail (id) {
      const params = {
        id: id
      }
      this.$http.get(`/api/services/inquiryApp/entrust/GetEntrustReceipt`, params)
        .then(res => {
          console.log(33, res);
          this.indentDetail = res.result
        }
        )
    }
  },
};
</script>
<style lang="less" scoped>
.indent-detail-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.indent-detail-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.timeline-wrapper {
  width: 100%;
  padding: 20px;
  margin: 20px 0;
  border: 1px solid #ededed;
  cursor: default;
  .el-steps {
    justify-content: center;
  }
}
.order-time-wrapper {
  border: 1px solid #ededed;
  div {
    height: 45px;
    display: flex;
    &:first-child {
      background-color: #f5f5f5;
    }
    span {
      text-align: center;
      line-height: 45px;
      color: #2f343c;
      &:nth-child(1) {
        width: 200px;
      }
      &:nth-child(2) {
        width: 300px;
      }
    }
  }
}
.order-list-wrapper {
  .title {
    font-size: 14px;
    font-weight: 600px;
    margin: 15px 0;
  }
}
.el-table {
  /deep/ .el-table__expanded-cell {
    padding: 0;
  }
}
.batch-list {
  background-color: rgba(239, 242, 249, 0.2);
  padding-left: 35px;
}
.batch-item-wrapper {
  height: 50px;
  display: flex;
  align-items: center;
  .batch-item {
    flex: 1;
    white-space: nowrap;
    margin-right: 20px;
    font-size: 12px;
    .batch-name {
      color: #b7bbc8;
      margin-bottom: 5px;
    }
    .batch-data {
      color: #2f343c;
      display: flex;
      align-items: center;
    }
  }
  .batch-quality {
    display: flex;
    align-items: center;
    .batch-name {
      margin-right: 10px;
      margin-bottom: 0;
    }
  }
}
</style>